var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAverageordervalue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.3359,
    cy: 30.5,
    r: 30,
    fill: "#EB863C",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5186_10927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.4906 29.642C45.4798 30.4832 45.4298 30.9117 45.3318 31.0519C45.1902 31.2245 44.2754 31.2353 28.3752 31.2676L11.5603 31.2892L11.534 31.551C11.5122 31.6804 11.6309 32.5083 11.5558 32.0579L11.7289 32.9074H28.4786C37.6811 32.9074 45.2827 32.9074 45.3589 32.9074C45.4351 32.9074 45.4678 32.9505 45.3273 32.4246C45.2946 32.4785 45.3164 32.5324 45.3708 32.5324C45.4471 32.5324 45.4906 32.9638 45.4906 33.7512C45.4906 34.4306 45.5342 35.013 45.5995 35.0777C45.6758 35.1532 45.8827 35.0346 46.2312 34.7003C46.5144 34.4306 46.7322 34.1718 46.7213 34.1286C46.7104 34.0963 46.9609 33.8159 47.2985 33.5139C47.6252 33.2119 47.8974 32.9315 47.9083 32.8883C47.9192 32.8452 48.1044 32.6079 48.344 32.3707C48.5727 32.1334 48.7578 31.8638 48.7578 31.7775C48.7578 31.6912 48.5944 31.4431 48.3984 31.2382C48.2133 31.0333 48.0608 30.8607 48.0717 30.8392C48.0935 30.8284 47.8539 30.5803 47.549 30.2999C47.2331 30.0087 46.9609 29.7067 46.9173 29.6204C46.8302 29.3939 45.7738 28.4341 45.6104 28.4341C45.5342 28.4341 45.4906 28.8115 45.4906 29.642Z",
    fill: "#EB853C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.3203,
    y: 43.5078,
    width: 34.3621,
    height: 1.494,
    rx: 0.747002,
    fill: "#EB853C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.5391,
    y: 34.6602,
    width: 4.25216,
    height: 7.58494,
    rx: 0.576924,
    fill: "#EB853C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.4766,
    y: 34.6602,
    width: 4.25216,
    height: 7.58494,
    rx: 0.576924,
    fill: "#EB853C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.3828,
    y: 34.6602,
    width: 4.25216,
    height: 7.58494,
    rx: 0.576924,
    fill: "#EB853C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.3125,
    y: 34.6602,
    width: 4.25216,
    height: 7.58494,
    rx: 0.576924,
    fill: "#EB853C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.5391,
    y: 22.0117,
    width: 4.25216,
    height: 7.58494,
    rx: 0.576924,
    fill: "#EB853C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.4766,
    y: 24.7695,
    width: 4.25216,
    height: 4.82678,
    rx: 0.576924,
    fill: "#EB853C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.4062,
    y: 15,
    width: 4.25216,
    height: 14.5953,
    rx: 0.576924,
    fill: "#EB853C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.3281,
    y: 22.0117,
    width: 4.25216,
    height: 7.58494,
    rx: 0.576924,
    fill: "#EB853C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5186_10927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverageordervalue);
export default __webpack_public_path__ + "static/media/averageordervalue.face65b53b7a884f64198e61e1249832.svg";
export { ForwardRef as ReactComponent };